<template lang="pug">
#dados-gerais-operacao
    card
        el-form(
            label-position='top',
            ref='dadosGerais',
            :model='dadosGerais',
            :rules='dadosGeraisRules'
        )
            .row
                .col-8
                    el-form-item(prop='nome')
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.tabela.nome') }}
                        el-input(
                            v-model='dadosGerais.nome',
                            :maxlength='255',
                            :placeholder="$t('mensagens.operacao.tabela.nome')"
                        )
                .col-4
                    el-form-item(prop='categoria')
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.tabela.categoria') }}
                        el-select.w-100(
                            v-model='dadosGerais.categoria.id',
                            :placeholder="$t('mensagens.operacao.acoes.selecione')",
                            @change='atualizarDadosGerais',
                            value-key='id'
                        )
                            el-option(
                                v-for='categoria in listaCategorias',
                                :key='categoria.id',
                                :label='categoria.nome',
                                :value='categoria.id'
                            )

                .col-12
                    el-form-item
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.formularioGeral.descricao') }}

                        el-input(
                            type='textarea',
                            :rows='5',
                            v-model='dadosGerais.descricao',
                            :maxlength='8000',
                            :placeholder="$t('mensagens.operacao.formularioGeral.descricao')",
                            @change='atualizarDadosGerais'
                        )
            .row
                .col-3
                    el-form-item(prop='identificadorOperacao')
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.formularioGeral.identificadorOperacao') }}

                        el-input(
                            v-model='dadosGerais.identificadorOperacao',
                            :placeholder="$t('mensagens.operacao.formularioGeral.identificadorOperacao')",
                            @change='atualizarDadosGerais'
                        )
                .col-3
                    el-form-item(prop='numeroContrato')
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.formularioGeral.numeroContrato') }}

                        el-input(
                            v-model='dadosGerais.numeroContrato',
                            :placeholder="$t('mensagens.operacao.formularioGeral.numeroContrato')",
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 {{ $t('mensagens.operacao.formularioGeral.dataContratacao') }}

                        el-date-picker(
                            v-model='dadosGerais.dataContratacao',
                            type='date',
                            :placeholder="$t('mensagens.operacao.acoes.selecione')",
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 {{ $t('mensagens.operacao.formularioGeral.dataLiberacao') }}

                        el-date-picker(
                            v-model='dadosGerais.dataLiberacao',
                            type='date',
                            :placeholder="$t('mensagens.operacao.acoes.selecione')",
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
                .col-2
                    el-form-item
                        template(slot='label')
                            span.label.pb-10 {{ $t('mensagens.operacao.tabela.vigencia') }}

                        el-date-picker(
                            v-model='dadosGerais.vigencia',
                            :picker-options='datePickerOptions',
                            type='date',
                            :placeholder="$t('mensagens.operacao.acoes.selecione')",
                            format='dd/MM/yyyy',
                            disabledDate='',
                            style='width: 100%',
                            @change='atualizarDadosGerais'
                        )
            .row
                .col-3
                    el-form-item(prop='valorTotalOperacao')
                        template(slot='label')
                            span.label {{ $t('mensagens.operacao.formularioGeral.valorTotalOperacao') }}

                        money.campo-extendido.el-input__inner(
                            v-model='dadosGerais.valorTotalOperacao',
                            v-bind='moneyMask',
                            :placeholder="$t('mensagens.operacao.formularioGeral.valorTotalOperacao')"
                        )
</template>

<script>
import Card from '../../Card.vue';
import { Money } from 'v-money';
import OperacaoService from '@/services/OperacaoService';
import { ProtocolosService } from '@/services/ProtocolosService';

export default {
    name: 'FormularioDadosGeraisOperacao',

    emits: ['dadosGerais', 'atualizaValidarDadosGerais'],

    props: {
        operacaoEditarOuClonar: {
            type: Object,
            required: false,
            default: null
        }
    },

    components: {
        Card,
        Money
    },

    data() {
        const validarCategoria = (rule, value, callback) => {
            if (!this.dadosGerais.categoria.id) {
                return callback(new Error(this.$t('mensagens.operacao.notificacao.categoriaOperacaoNecessaria')));
            }
            callback();
        };
        const validarValorTotal = (rule, value, callback) => {
            if (this.dadosGerais.valorTotalOperacao === 0) {
                return callback(new Error(this.$t('mensagens.operacao.notificacao.valorTotalNecessario')));
            }
            callback();
        };
        return {
            dadosGeraisRules: {
                identificadorOperacao: [
                    {
                        required: true,
                        message: this.$t('mensagens.operacao.notificacao.idNecessario'),
                        trigger: 'blur'
                    },
                    {
                        max: 60,
                        message: this.$t('mensagens.operacao.notificacao.idTamanhoMaximo'),
                        trigger: ['blur', 'change']
                    }
                ],
                categoria: [
                    {
                        required: true,
                        validator: validarCategoria,
                        trigger: 'change'
                    }
                ],
                valorTotalOperacao: [
                    {
                        required: true,
                        validator: validarValorTotal,
                        trigger: 'blur'
                    }
                ]
            },
            dadosGerais: {
                nome: '',
                descricao: '',
                identificadorOperacao: '',
                numeroContrato: '',
                categoria: {
                    id: null,
                    atividadeObrigatoria: false
                },
                vigencia: null,
                dataLiberacao: null,
                dataContratacao: null,
                valorTotalOperacao: 0
            },
            listaCategorias: [],
            objetoCicloAno: [],
            datePickerOptions: {
                disabledDate(date) {
                    const today = new Date();
                    today.setUTCHours(0, 0, 0, 0);
                    return date < today;
                }
            },
            moneyMask: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        };
    },

    async mounted() {
        await this.buscarCategorias();
        this.atualizarDadosGerais();
        setTimeout(this.verificarEdicao, 1000);
    },

    methods: {
        atualizarDadosGerais() {
            if (
                this.listaCategorias.length > 0 &&
                this.dadosGerais.categoria.id
            ) {
                this.dadosGerais.categoria.atividadeObrigatoria =
                    this.listaCategorias.find(
                        item => item.id === this.dadosGerais.categoria.id
                    ).atividadeObrigatoria;
            }

            this.$emit('dadosGerais', this.dadosGerais);
        },

        async buscarCategorias() {
            try {
                // Buscar protocolo padrão do usuário
                const protocolos = await ProtocolosService.buscarProtocolosPorUsuario();
                const protocoloPadrao = protocolos.find(p => p.protocoloPadrao === true);

                if (!protocoloPadrao) {
                    throw new Error(this.$t('mensagens.operacao.notificacao.protocoloPadraoNaoEncontrado'));
                }

                // Buscar categorias para o protocolo
                const { data } = await OperacaoService.buscarCategorias(protocoloPadrao.codigo);
                this.listaCategorias = data.itens;
            } catch (error) {
                this.$notify.error({
                    message: error.message || this.$t('mensagens.sistema.erroBuscarCategorias')
                });
            }
        },

        async validarFormulario() {
            return this.$refs.dadosGerais
                .validate()
                .then(value => value)
                .catch(() => false);
        },

        verificarEdicao() {
            if (this.operacaoEditarOuClonar !== null) {
                this.dadosGerais = this.operacaoEditarOuClonar.dadosGerais;

                if (this.dadosGerais.vigencia !== null) {
                    let dataString =
                        this.dadosGerais.vigenciaFormatado.split('/');
                    this.dadosGerais.vigencia = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                if (this.dadosGerais.dataLiberacao !== null) {
                    let dataString =
                        this.dadosGerais.dataLiberacaoFormatado.split('/');
                    this.dadosGerais.dataLiberacao = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                if (this.dadosGerais.dataContratacao !== null) {
                    let dataString =
                        this.dadosGerais.dataContratacaoFormatado.split('/');
                    this.dadosGerais.dataContratacao = new Date(
                        `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                    );
                }

                this.atualizarDadosGerais();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#dados-gerais-operacao {
    .label {
        font-size: 14px;
        color: var(--primary);
        font-weight: normal !important;
    }
}
</style>
